import { z } from "zod";
import { captureBrowserEvent } from "../browser";

export const JobSharedPlatformSchema = z.enum([
  "whatsapp",
  "facebook",
  "twitter",
  "linkedin",
  "copy_link",
  "native_share",
]);

export const JobSharedSourceSchema = z.enum([
  "listing_page",
  "employer_detail",
  "employer_jobs_table",
]);

export const JobSharedEventSchema = z.object({
  job_id: z.string().min(1),
  organization_id: z.string().min(1),
  platform: JobSharedPlatformSchema,
  source: JobSharedSourceSchema,
  user_type: z.enum(["employee", "employer", "anonymous"]),
});

export type JobSharedPlatform = z.infer<typeof JobSharedPlatformSchema>;
export type JobSharedSource = z.infer<typeof JobSharedSourceSchema>;
export type JobSharedEvent = z.infer<typeof JobSharedEventSchema>;

export const JOB_SHARED_EVENT_NAME = "job.shared" as const;

export function trackJobShared(event: JobSharedEvent) {
  const parsed = JobSharedEventSchema.safeParse(event);
  if (!parsed.success) {
    return;
  }

  captureBrowserEvent(JOB_SHARED_EVENT_NAME, parsed.data);
}
